<template>
  <div>
    <div class="products-list-shim" v-if="bracketsLoader">
      <content-placeholders :rounded="true">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>
      <content-placeholders class="mt-3" :rounded="true">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>
      <content-placeholders class="mt-3" :rounded="true">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>
    </div>
    <div v-if="allBracketsData && allBracketsData.length > 0">
      <h6 class="brackets-text">Brackets</h6>
      <!-- Loop through all brackets -->
      <div v-for="bracket in allBracketsData" :key="bracket.bracketGuid" class="bracket-wrapper">
        <!-- Bracket Header -->
        <div class="bracket-details-div">
          <div class="bracket-name-count-div">
            <div class="bracket-name">{{ bracket.bracketName }}</div>
            <div class="teams-count-format">{{ bracket.teamCounts }} Teams - {{ bracket.bracketFormat }} - {{
              bracket.gameCounts }} Games</div>
          </div>
        </div>

        <!-- Single Elimination Bracket Display -->
        <div v-if="bracket.bracketType === 'single'" class="bracket-container bracket-container2">
          <div class="bracket-section winner-section" :style="{ height: `${bracket.winnerBracketHeight}px` }">
            <div class="winner-bracket-label">Winner Bracket</div>
            <div class="bracket-rounds-container">
              <div v-for="(round, rIndex) in bracket.singleEliminationRounds"
                :key="`${bracket.bracketGuid}-single-${rIndex}`" class="bracket-round">
                <div v-for="(match, mIndex) in round" :key="`${bracket.bracketGuid}-single-${rIndex}-${mIndex}`"
                  class="bracket-match" :style="{
                    top: `${match.top}px`,
                    height: `${match.matchHeight}px`,
                    position: 'absolute'
                  }">
                  <div class="assigned-game-info top-left">{{ match.gameName }}</div>
                  <div v-if="match.originalGame.assignedTime" class="assigned-game-info bottom-left">
                    {{ match.originalGame.assignedTime }}
                  </div>
                  <div v-else class="assigned-game-info unassigned-game-info bottom-left">Not scheduled</div>
                  <div v-if="match.originalGame.assignedDate" class="assigned-game-info top-right">
                    {{ formatAssignedDate(match.originalGame.assignedDate) }}
                  </div>
                  <div v-if="match.originalGame.assignedFieldName" class="assigned-game-info bottom-right">
                    {{ match.originalGame.assignedFieldName }}
                  </div>
                  <div class="game-container">
                                            <!-- For Team 1 -->
<div class="team-line top-team" :class="{
  'winner-team': match.isTeam1Winner,
  'loser-team': match.isGameFinished && !match.isTeam1Winner
}">
  <span class="seed">{{ match.seed1 || '' }}</span>
  <span class="team-name">{{ match.team1 || '' }}</span>
  <div v-if="match.isTeam1Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>

<!-- For Team 2 -->
<div class="team-line bottom-team" :class="{
  'winner-team': match.isTeam2Winner,
  'loser-team': match.isGameFinished && !match.isTeam2Winner
}">
  <span class="seed">{{ match.seed2 || '' }}</span>
  <span class="team-name">{{ match.team2 || '' }}</span>
  <div v-if="match.isTeam2Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Double Elimination Bracket Display -->
        <div v-if="bracket.bracketType === 'double'" class="double-bracket-container double-bracket-container2">
          <!-- Main Bracket Container -->
          <div class="main-bracket-wrapper">
            <!-- Winner Bracket Section -->
            <div class="bracket-section winner-section" :style="{ height: `${bracket.winnerBracketHeight}px` }">
              <div class="winner-bracket-label">Winner Bracket</div>
              <div class="bracket-rounds-container">
                <div v-for="(round, rIndex) in bracket.winnerBracketRounds"
                  :key="`${bracket.bracketGuid}-winner-${rIndex}`" class="bracket-round">
                  <div v-for="(match, mIndex) in round" :key="`${bracket.bracketGuid}-winner-${rIndex}-${mIndex}`"
                    class="bracket-match" :style="{
                      top: `${match.top}px`,
                      height: `${match.matchHeight}px`,
                      position: 'absolute'
                    }">
                    <!-- Game Info Overlays -->
                    <div class="assigned-game-info top-left">{{ match.gameName }}</div>
                    <div v-if="match.originalGame.assignedTime" class="assigned-game-info bottom-left">
                      {{ match.originalGame.assignedTime }}
                    </div>
                    <div v-else class="assigned-game-info unassigned-game-info bottom-left">Not scheduled</div>
                    <div v-if="match.originalGame.assignedDate" class="assigned-game-info top-right">
                      {{ formatAssignedDate(match.originalGame.assignedDate) }}
                    </div>
                    <div v-if="match.originalGame.assignedFieldName" class="assigned-game-info bottom-right">
                      {{ match.originalGame.assignedFieldName }}
                    </div>
                    <div class="game-container">
                                              <!-- For Team 1 -->
<div class="team-line top-team" :class="{
  'winner-team': match.isTeam1Winner,
  'loser-team': match.isGameFinished && !match.isTeam1Winner
}">
  <span class="seed">{{ match.seed1 || '' }}</span>
  <span class="team-name">{{ match.team1 || '' }}</span>
  <div v-if="match.isTeam1Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>

<!-- For Team 2 -->
<div class="team-line bottom-team" :class="{
  'winner-team': match.isTeam2Winner,
  'loser-team': match.isGameFinished && !match.isTeam2Winner
}">
  <span class="seed">{{ match.seed2 || '' }}</span>
  <span class="team-name">{{ match.team2 || '' }}</span>
  <div v-if="match.isTeam2Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Grand Final Section -->
            <div class="bracket-section grand-final-section" :style="{ height: `${bracket.winnerBracketHeight}px` }">
              <div class="bracket-rounds-container">
                <div class="bracket-round">
                  <div v-for="(match, mIndex) in bracket.grandFinalRounds"
                    :key="`${bracket.bracketGuid}-final-${mIndex}`" class="bracket-match final-match" :style="{
                      top: `${match.top}px`,
                      height: `${match.matchHeight}px`,
                      position: 'absolute'
                    }">
                    <!-- Game Info Overlays -->
                    <div class="assigned-game-info top-left">{{ match.gameName }}</div>
                    <div v-if="match.originalGame.assignedTime" class="assigned-game-info bottom-left">
                      {{ match.originalGame.assignedTime }}
                    </div>
                    <div v-else class="assigned-game-info unassigned-game-info bottom-left">Not scheduled</div>
                    <div v-if="match.originalGame.assignedDate" class="assigned-game-info top-right">
                      {{ formatAssignedDate(match.originalGame.assignedDate) }}
                    </div>
                    <div v-if="match.originalGame.assignedFieldName" class="assigned-game-info bottom-right">
                      {{ match.originalGame.assignedFieldName }}
                    </div>
                    <div class="game-container grand-final-match">
                                              <!-- For Team 1 -->
<div class="team-line top-team" :class="{
  'winner-team': match.isTeam1Winner,
  'loser-team': match.isGameFinished && !match.isTeam1Winner
}">
  <span class="seed">{{ match.seed1 || '' }}</span>
  <span class="team-name">{{ match.team1 || '' }}</span>
  <div v-if="match.isTeam1Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>

<!-- For Team 2 -->
<div class="team-line bottom-team" :class="{
  'winner-team': match.isTeam2Winner,
  'loser-team': match.isGameFinished && !match.isTeam2Winner
}">
  <span class="seed">{{ match.seed2 || '' }}</span>
  <span class="team-name">{{ match.team2 || '' }}</span>
  <div v-if="match.isTeam2Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="main-bracket-wrapper">
          <!-- Loser Bracket Section -->
          <div class="bracket-section loser-section" :style="{ height: `${bracket.loserBracketHeight}px` }">
            <div class="loser-bracket-label">Loser Bracket</div>
            <div class="bracket-rounds-container">
              <div v-for="(round, rIndex) in bracket.loserBracketRounds" :key="`${bracket.bracketGuid}-loser-${rIndex}`"
                class="bracket-round">
                <div v-for="(match, mIndex) in round" :key="`${bracket.bracketGuid}-loser-${rIndex}-${mIndex}`"
                  class="bracket-match" :style="{
                    top: `${match.top}px`,
                    height: `${match.matchHeight}px`,
                    position: 'absolute'
                  }">
                  <!-- Game Info Overlays -->
                  <div class="assigned-game-info top-left">{{ match.gameName }}</div>
                  <div v-if="match.originalGame.assignedTime" class="assigned-game-info bottom-left">
                    {{ match.originalGame.assignedTime }}
                  </div>
                  <div v-else class="assigned-game-info unassigned-game-info bottom-left">Not scheduled</div>
                  <div v-if="match.originalGame.assignedDate" class="assigned-game-info top-right">
                    {{ formatAssignedDate(match.originalGame.assignedDate) }}
                  </div>
                  <div v-if="match.originalGame.assignedFieldName" class="assigned-game-info bottom-right">
                    {{ match.originalGame.assignedFieldName }}
                  </div>
                  <div class="game-container loser-match">
                                            <!-- For Team 1 -->
<div class="team-line top-team" :class="{
  'winner-team': match.isTeam1Winner,
  'loser-team': match.isGameFinished && !match.isTeam1Winner
}">
  <span class="seed">{{ match.seed1 || '' }}</span>
  <span class="team-name">{{ match.team1 || '' }}</span>
  <div v-if="match.isTeam1Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>

<!-- For Team 2 -->
<div class="team-line bottom-team" :class="{
  'winner-team': match.isTeam2Winner,
  'loser-team': match.isGameFinished && !match.isTeam2Winner
}">
  <span class="seed">{{ match.seed2 || '' }}</span>
  <span class="team-name">{{ match.team2 || '' }}</span>
  <div v-if="match.isTeam2Winner" class="trophy-icon">
    <img src="../../assets/Svg/trophy.svg" alt="Winner" />
  </div>
</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BracketView",
  data() {
    return {
      bracketGames: [],
      bracketType: '', // 'single' or 'double'
      singleEliminationRounds: [],
      winnerBracketRounds: [],
      loserBracketRounds: [],
      grandFinalRounds: [],
      // Add height tracking
      winnerBracketHeight: 0,
      loserBracketHeight: 0,
      events: {},
      eventName: "",
      showEventHeadingLoader: 0,
      bracketsLoader: 0,
      eventGuid: "",
      selectedTournament: {},
      selectedTournamentName: "",
      bracketName: "",
      bracketDescription: "",
      teamCounts: "",
      gameCounts: "",
      bracketFormat: "",
      showFieldsLoader: 1,
      searchQuery: '',
      eventId: null,
      startDate: null,
      endDate: null,
      startTime: "08:00 AM",
      endTime: "05:00 PM",
      tournament_time: "",
      scheduleData: [],
      fieldAssignments: [],
      divisionColorMap: {},
      tournamentTeams: [],
      pools: [],
      bracketTeams: [],
      bracketCount: 0,
      activeBracketIndex: 0,
      showBracketLoader: 0,
      bracketGuid: "",
      bracketId: 0,
      firstBracket: "",
      allBracketsData: [],

      allDay: false,
    };
  },
  props: {
    tournamentData: {
      typeof: Object,
    },
    currentIsUmpire: {
      type: String,
    },
    currentIsAdmin: {
      type: String,
    },
    association_id: {
      type: Number,
    },
  },
  async mounted() {
    await this.TournamentsDetailData();
    const storedTournamentID = localStorage.getItem("tournamentID");
    if (storedTournamentID) {
      this.tournament_guid = storedTournamentID;
    }
    // this.allBracketsData = [];
    await this.getAllBrackets();

    this.$root.$on("showTournamentForSwitch", () => {
      this.allBracketsData = [];
      this.getAllBrackets();
    });
    this.$root.$on("refreshBracket", () => {
      this.allBracketsData = [];
      this.getAllBrackets();
    });

    this.$root.$on("changeDivision", (tournamentID) => {
      this.tournament_guid = tournamentID;
      localStorage.setItem("tournamentID", tournamentID); // Save to localStorage
      this.allBracketsData = [];
      this.getAllBrackets();
    });
  },
  methods: {
    async TournamentsDetailData() {
      this.eventGuid = this.$route.params.id;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}event/tournamentListForAdminEvents?page=${this.divisionPage}`,
          { event_guid: this.eventGuid }
        );

        if (response.data.statusCode === 200) {

          this.tournamentsData = response.data.data.eventTournaments.data;
          this.events = response.data.data.teamEventData;
          this.startDate = response.data.data.teamEventData.exactStartDate;
          this.allDay = response.data.data.teamEventData.allDay;
          this.endDate = response.data.data.teamEventData.exactEndDate;
          this.eventId = response.data.data.teamEventData.id;
          this.eventName = response.data.data.teamEventData.eventName;
          this.startTime = this.allDay === "true" ? "12:00 AM" : response.data.data.teamEventData.exactStartTime;
          this.endTime = this.allDay === "true" ? "11:59 PM" : response.data.data.teamEventData.exactEndTime;
          this.tournament_time = Number(response.data.data.teamEventData?.time_interval ?? 30);
          this.association_id = response.data.data?.user_association_role?.association_id;

        } else if (response.data.statusCode === 404) {
          this.$alert(response.data.message, 'Error');
          this.$router.push({ name: "Teams" });

          this.showLoader = 0; // Hide loader
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoaderTournament = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoaderTournament = 0;
      } finally {
        this.showEventHeadingLoader = 0;
        this.showLoaderTournament = 0;
      }
    },
    getAllBrackets() {
      console.log("good tournament data", this.tournamentData)
      const Guid = this.tournament_guid ? this.tournament_guid : this.tournamentData[0].guid;
      var formData = new FormData();
      formData.append("tournament_guid", Guid);
      formData.append("association_id", this.association_id);

      this.showBracketLoader = 1;
      return axios
        .post(
          process.env.VUE_APP_API_URL +
          "tournaments/brackets/getTournamentBrackets",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.brackets = response.data.data;
            this.firstBracket = response.data.data[0].guid
            console.log("brackets", this.firstBracket)
            this.bracketCount = this.brackets.length;

            // Get data for all brackets
            this.getAllBracketsData();
          } else {
            this.showBracketLoader = 0;
          }
        });
    },

    // New method to get data for all brackets
    async getAllBracketsData() {
      this.bracketsLoader = 1;
      this.allBracketsData = []; // Reset the array

      try {
        // Loop through all brackets and get their data
        for (let i = 0; i < this.brackets.length; i++) {
          const bracket = this.brackets[i];
          await this.getSingleBracketData(bracket.guid, i);
        }
        this.bracketsLoader = 0;
      } catch (error) {
        console.error('Error loading brackets:', error);
        this.bracketsLoader = 0;
      }
    },

    async getSingleBracketData(bracketGuid, index) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}tournaments/brackets/getBracketDetails`, {
          params: {
            bracket_guid: bracketGuid,
            association_id: localStorage.getItem("association_id"),
          }
        });

        if (response.data.statusCode === 200) {
          const bracketData = {
            index: index,
            bracketGuid: bracketGuid,
            bracketGames: response.data.data.games,
            eventGuid: response.data.data.event_tournament.event.guid,
            selectedTournament: response.data.data.event_tournament,
            selectedTournamentName: response.data.data.event_tournament.tournamentName,
            bracketName: response.data.data.bracket_name,
            bracketDescription: response.data.data.bracket_description,
            bracketId: response.data.data.id,
            bracketTeams: response.data.data.bracket_teams,
            teamCounts: response.data.data.teamCounts,
            gameCounts: response.data.data.gameCounts,
            bracketFormat: response.data.data.event_tournament.bracket_format_info?.bracket_name
              ?? response.data.data.event_tournament.event?.bracket_format?.bracket_name,

            // Process bracket data for this specific bracket
            ...this.processSingleBracketData(response.data.data.games)
          };

          this.allBracketsData.push(bracketData);
        } else {
          console.error(`Error loading bracket ${bracketGuid}:`, response.data.message);
        }
      } catch (error) {
        console.error(`Error loading bracket ${bracketGuid}:`, error);
      }
    },

    // New method to process bracket data for a single bracket (returns data instead of setting instance variables)
    processSingleBracketData(bracketGames) {
      if (!bracketGames || bracketGames.length === 0) return {};

      // Determine bracket type from games
      const bracketTypes = bracketGames.map(game => game.bracket_type);
      const hasDoubleElimination = bracketTypes.includes('winner') || bracketTypes.includes('loser') || bracketTypes.includes('grand_final');

      const bracketType = hasDoubleElimination ? 'double' : 'single';
      let processedData = { bracketType };

      if (bracketType === 'single') {
        processedData = { ...processedData, ...this.processSingleEliminationBracketData(bracketGames) };
      } else {
        processedData = { ...processedData, ...this.processDoubleEliminationBracketData(bracketGames) };
      }

      return processedData;
    },

    processSingleEliminationBracketData(bracketGames) {
      // Group games by round_number (only for single bracket_type)
      const roundsMap = {};
      bracketGames
        .filter(game => game.bracket_type === 'single')
        .forEach(game => {
          if (!roundsMap[game.round_number]) {
            roundsMap[game.round_number] = [];
          }
          roundsMap[game.round_number].push(this.formatGameData(game, bracketGames));
        });

      // Convert to array and sort by round number
      const rounds = Object.keys(roundsMap)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map(roundNum => {
          return roundsMap[roundNum].sort((a, b) => a.position - b.position);
        });

      // Add spacing to rounds starting from 50px (consistent with double elimination)
      this.addSpacingToRoundsForBracket(rounds, bracketGames, 50);

      // Check and adjust positioning to ensure it starts at 50px
      const minTop = this.calculateMinTopPosition(rounds);
      if (minTop !== 50) {
        const offset = 50 - minTop;
        this.adjustPositionsWithOffset(rounds, offset);
      }

      // Calculate bracket height with padding (consistent with double elimination)
      const singleEliminationHeight = this.calculateRoundsHeight(rounds) + 40; // Add 40px padding

      return {
        singleEliminationRounds: rounds,
        singleEliminationHeight: singleEliminationHeight,
        winnerBracketHeight: singleEliminationHeight // For template compatibility
      };
    },

    processDoubleEliminationBracketData(bracketGames) {
      // Separate games by bracket_type
      const winnerGames = bracketGames.filter(game => game.bracket_type === 'winner');
      const loserGames = bracketGames.filter(game => game.bracket_type === 'loser');
      const grandFinalGames = bracketGames.filter(game => game.bracket_type === 'grand_final');

      // Process winner bracket
      const winnerBracketRounds = this.groupGamesByRounds(winnerGames.map(game => this.formatGameData(game, bracketGames)));
      this.addSpacingToRoundsForBracket(winnerBracketRounds, bracketGames, 50); // Start from 50px for winner bracket

      // Check and adjust winner bracket positioning to ensure it starts at 50px
      const winnerMinTop = this.calculateMinTopPosition(winnerBracketRounds);
      if (winnerMinTop !== 50) {
        const offset = 50 - winnerMinTop;
        this.adjustPositionsWithOffset(winnerBracketRounds, offset);
      }

      // Calculate winner bracket height
      const winnerBracketHeight = this.calculateRoundsHeight(winnerBracketRounds) + 40; // Add padding

      // Process loser bracket - keep positioning independent from winner bracket
      const loserBracketRounds = this.groupGamesByRounds(loserGames.map(game => this.formatGameData(game, bracketGames)));
      this.addSpacingToRoundsForBracket(loserBracketRounds, bracketGames, 50); // Start from 50px for loser bracket

      // Check and adjust loser bracket positioning to ensure it starts at 50px
      const loserMinTop = this.calculateMinTopPosition(loserBracketRounds);
      if (loserMinTop !== 50) {
        const offset = 50 - loserMinTop;
        this.adjustPositionsWithOffset(loserBracketRounds, offset);
      }

      // Calculate loser bracket height
      const loserBracketHeight = this.calculateRoundsHeight(loserBracketRounds) + 40; // Add padding

      // Process grand final with proper connection to winner bracket final
      let grandFinalRounds = [];
      if (grandFinalGames.length > 0) {
        const formattedGrandFinal = grandFinalGames.map(game => this.formatGameData(game, bracketGames));

        // Find the final game of winner bracket (last round, last game)
        let winnerFinalGame = null;
        if (winnerBracketRounds.length > 0) {
          const lastWinnerRound = winnerBracketRounds[winnerBracketRounds.length - 1];
          if (lastWinnerRound.length > 0) {
            winnerFinalGame = lastWinnerRound[0]; // Usually there's only one final game
          }
        }

        // Set position and height for each grand final match
        formattedGrandFinal.forEach(match => {
          if (winnerFinalGame) {
            // Calculate the center of the winner bracket final game
            const winnerFinalCenter = winnerFinalGame.top + (winnerFinalGame.matchHeight / 2);

            // Calculate the bottom of the winner bracket final game
            const winnerFinalBottom = winnerFinalGame.top + winnerFinalGame.matchHeight;

            // Set grand final to start at winner bracket final center
            match.top = winnerFinalCenter;

            // Set grand final height to extend from center to below the winner bracket final
            // Adding extra height to extend below the winner bracket final
            const extensionHeight = winnerFinalGame.matchHeight / 2; // Half height of winner final
            match.matchHeight = (winnerFinalBottom - winnerFinalCenter) + extensionHeight;
          } else {
            // Fallback positioning if no winner final game found
            match.top = 50;
            match.matchHeight = 50;
          }
        });

        grandFinalRounds = formattedGrandFinal;
      }

      return {
        winnerBracketRounds,
        loserBracketRounds,
        grandFinalRounds,
        winnerBracketHeight,
        loserBracketHeight
      };
    },
    // Helper method to adjust all positions in rounds by an offset
    adjustPositionsWithOffset(rounds, offset) {
      rounds.forEach(round => {
        round.forEach(match => {
          if (match) {
            match.top += offset;
          }
        });
      });
    },

    // Helper method to calculate minimum top position across all rounds
    calculateMinTopPosition(rounds) {
      let minTop = Infinity;

      rounds.forEach(round => {
        round.forEach(match => {
          if (match && match.top < minTop) {
            minTop = match.top;
          }
        });
      });

      return minTop === Infinity ? 0 : minTop;
    },
    calculateRoundsHeight(rounds) {
      if (!rounds || rounds.length === 0) return 0;

      let maxHeight = 0;

      rounds.forEach(round => {
        round.forEach(match => {
          const bottomPosition = match.top + match.matchHeight;
          if (bottomPosition > maxHeight) {
            maxHeight = bottomPosition;
          }
        });
      });

      return maxHeight;
    },
    groupGamesByRounds(games) {
      const roundsMap = {};
      games.forEach(game => {
        if (!roundsMap[game.roundNumber]) {
          roundsMap[game.roundNumber] = [];
        }
        roundsMap[game.roundNumber].push(game);
      });

      return Object.keys(roundsMap)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map(roundNum => {
          return roundsMap[roundNum].sort((a, b) => a.position - b.position);
        });
    },
    formatGameData(game, bracketGames) {
      // Parse source teams
      const sourceTeam1 = this.parseSourceTeam(game.source_team_1);
      const sourceTeam2 = this.parseSourceTeam(game.source_team_2);

      // Helper function to get team display name
      const getTeamDisplayName = (teamData, sourceTeam) => {
        // If team data exists, show team name
        if (teamData?.team?.team_name) {
          return teamData.team.team_name;
        }

        // If source team is from a game, show "Winner of" or "Loser of"
        if (sourceTeam.type === 'game' && sourceTeam.id) {
          const sourceGame = bracketGames.find(g => g.id === sourceTeam.id);
          if (sourceGame) {
            const position = sourceTeam.position || 'winner'; // default to winner if position not specified
            const prefix = position === 'winner' ? 'Winner of' : 'Loser of';
            return `${prefix} ${sourceGame.game_name}`;
          }
        }

        // Return empty string if no team data and no source game
        return '';
      };

      // Helper function to get seed display
      const getSeedDisplay = (teamData, sourceTeam) => {
        // If team data exists, show seed
        if (teamData?.seed_count) {
          return teamData.seed_count;
        }

        // If source team is from a seed, show the seed number
        if (sourceTeam.type === 'seed' && sourceTeam.id) {
          return sourceTeam.id;
        }

        // Return empty string for game sources (no seed)
        return '';
      };

      // Determine if teams are winners or losers
      // Check if game has a winner and if team IDs match the winner ID
      const isGameFinished = !!game.winner_id;

      // Try both possible ID comparisons
      // First try comparing with tournament team ID (game.team_one.id)
      let isTeam1Winner = isGameFinished && game.team_one?.id === game.winner_id;
      let isTeam2Winner = isGameFinished && game.team_two?.id === game.winner_id;

      // If that didn't work, try comparing with actual team ID (game.team_one.team.id)
      if (isGameFinished && !isTeam1Winner && !isTeam2Winner) {
        isTeam1Winner = game.team_one?.team?.id === game.winner_id;
        isTeam2Winner = game.team_two?.team?.id === game.winner_id;
      }

      return {
        id: game.id,
        gameName: `#${game.game_name}` || `Game ${game.id}`,
        roundNumber: game.round_number,
        position: game.position,
        team1: getTeamDisplayName(game.team_one, sourceTeam1),
        team2: getTeamDisplayName(game.team_two, sourceTeam2),
        seed1: getSeedDisplay(game.team_one, sourceTeam1),
        seed2: getSeedDisplay(game.team_two, sourceTeam2),
        top: 0,
        matchHeight: 50,
        originalGame: game,
        isGameFinished: isGameFinished,
        isTeam1Winner: isTeam1Winner,
        isTeam2Winner: isTeam2Winner,
        winner_id: game.winner_id
      };
    },

    parseSourceTeam(sourceTeamString) {
      try {
        if (!sourceTeamString) return { type: null, id: null, position: null };
        const parsed = JSON.parse(sourceTeamString);
        return {
          type: parsed.type,
          id: parsed.id,
          position: parsed.position || null
        };
      } catch (e) {
        return { type: null, id: null, position: null };
      }
    },
    formatAssignedDate(date) {
      if (!date) return '';

      const d = new Date(date);

      const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      const dayName = dayNames[d.getDay()];       // getDay() returns 0 (Sun) to 6 (Sat)
      const month = monthNames[d.getMonth()];     // getMonth() returns 0 to 11
      const day = d.getDate();                    // getDate() returns 1 to 31

      return `${dayName} ${month} ${day}`;
    },
    addSpacingToRoundsForBracket(rounds, bracketGames, offsetY = 0) {
      const matchHeight = 50;
      const verticalGap = 50;

      if (rounds.length === 0) return;

      // Position first round matches based on API position, not array index
      rounds[0].forEach((match) => {
        // Use API position field instead of array index
        const apiPosition = match.position || 0; // Fallback to 0 if position not provided
        match.top = offsetY + (apiPosition - 1) * (matchHeight + verticalGap); // API position is 1-based
        match.matchHeight = matchHeight;
      });

      // Position subsequent rounds
      for (let r = 1; r < rounds.length; r++) {
        const prevRound = rounds[r - 1];
        const currRound = rounds[r];

        // First pass: Position matches based on their relationships
        for (let i = 0; i < currRound.length; i++) {
          const currentMatch = currRound[i];

          // Skip if match doesn't exist
          if (!currentMatch) continue;

          // Find source games that feed into this match
          const sourceGames = this.findSourceGamesForBracket(currentMatch, prevRound, bracketGames);

          if (sourceGames.length >= 2) {
            // Position between the two source games
            const game1 = sourceGames[0];
            const game2 = sourceGames[1];

            // Sort games by their vertical position
            const sortedGames = [game1, game2].sort((a, b) => a.top - b.top);
            const upperGame = sortedGames[0];
            const lowerGame = sortedGames[1];

            // Calculate centers of source games
            const upperCenter = upperGame.top + upperGame.matchHeight / 2;
            const lowerCenter = lowerGame.top + lowerGame.matchHeight / 2;

            // Position current match to span from upper game center to lower game center
            const startY = upperCenter;
            const endY = lowerCenter;
            const height = Math.max(matchHeight, endY - startY);

            currentMatch.top = startY - (height - (endY - startY)) / 2;
            currentMatch.matchHeight = height;

          } else if (sourceGames.length === 1) {
            // Position based on single source game
            const sourceGame = sourceGames[0];
            const sourceCenter = sourceGame.top + sourceGame.matchHeight / 2;

            // Set the current match to have the same height as the source game
            currentMatch.matchHeight = sourceGame.matchHeight;

            // Determine direction to extend based on available space
            const extendDirection = this.getExtensionDirection(currentMatch, currRound, i, sourceGame, prevRound);

            if (extendDirection === 'up') {
              currentMatch.top = sourceCenter - sourceGame.matchHeight;
            } else if (extendDirection === 'down') {
              currentMatch.top = sourceCenter;
            } else {
              currentMatch.top = sourceCenter - sourceGame.matchHeight / 2;
            }

          } else {
            // Fallback: Use API position if available, otherwise use traditional pairing
            if (currentMatch.position) {
              // Respect API position for matches without clear source games
              const apiPosition = currentMatch.position;

              // Calculate proper spacing considering previous matches in this round
              let calculatedTop = offsetY + (apiPosition - 1) * (matchHeight + verticalGap);

              // Check if we need to adjust based on previous matches in this round
              const prevMatchesInRound = currRound.slice(0, i).filter(m => m != null);
              if (prevMatchesInRound.length > 0) {
                // Find the last positioned match
                const lastMatch = prevMatchesInRound[prevMatchesInRound.length - 1];
                const lastMatchBottom = lastMatch.top + Math.max(lastMatch.matchHeight, matchHeight);
                const minRequiredTop = lastMatchBottom + verticalGap;

                // Use the maximum of calculated position and minimum required position
                calculatedTop = Math.max(calculatedTop, minRequiredTop);
              }

              currentMatch.top = calculatedTop;
              currentMatch.matchHeight = matchHeight;
            } else {
              // Traditional pairing logic as fallback
              const match1Index = i * 2;
              const match2Index = i * 2 + 1;

              const match1 = prevRound[match1Index];
              const match2 = prevRound[match2Index];

              if (match1 && match2) {
                const center1 = match1.top + matchHeight / 2;
                const center2 = match2.top + matchHeight / 2;

                const upperCenter = Math.min(center1, center2);
                const lowerCenter = Math.max(center1, center2);
                const height = Math.max(matchHeight, lowerCenter - upperCenter);

                currentMatch.top = upperCenter - (height - (lowerCenter - upperCenter)) / 2;
                currentMatch.matchHeight = height;
              } else if (match1) {
                currentMatch.top = match1.top;
                currentMatch.matchHeight = matchHeight;
              } else {
                // Position with standard spacing if no source games
                currentMatch.top = offsetY + i * (matchHeight + verticalGap);
                currentMatch.matchHeight = matchHeight;
              }
            }
          }
        }

        // MODIFIED: Only resolve collisions if they don't disturb API positioning
        this.resolveCollisionsRespectingPositions(currRound, verticalGap, matchHeight);
      }
    },

    // Modified collision resolution that respects API positions and maintains proper gaps
    resolveCollisionsRespectingPositions(matches, minGap, defaultHeight) {
      // Filter out null/undefined matches
      const validMatches = matches.filter(match => match != null);

      if (validMatches.length <= 1) return;

      // Sort by current vertical position to check for overlaps
      validMatches.sort((a, b) => a.top - b.top);

      // Ensure minimum gaps between all matches
      for (let i = 1; i < validMatches.length; i++) {
        const currentMatch = validMatches[i];
        const prevMatch = validMatches[i - 1];

        // Use the larger of the two match heights for gap calculation
        const prevMatchHeight = Math.max(prevMatch.matchHeight, defaultHeight);
        const prevBottom = prevMatch.top + prevMatchHeight;
        const currentTop = currentMatch.top;

        // Calculate required minimum gap
        const requiredGap = minGap;
        const actualGap = currentTop - prevBottom;

        // If gap is insufficient, adjust position
        if (actualGap < requiredGap) {
          const adjustment = requiredGap - actualGap;

          console.log(`Adjusting gap between matches: current gap ${actualGap}px, required ${requiredGap}px`);

          // If current match has API position, try to move previous matches up first
          if (currentMatch.position) {
            // Try to move previous match up if possible
            if (!prevMatch.position) {
              const newPrevTop = currentTop - prevMatchHeight - requiredGap;
              if (newPrevTop >= 0) {
                prevMatch.top = newPrevTop;
                continue;
              }
            }
            // If can't move previous match, move current match down minimally
            currentMatch.top += adjustment;
          }
          // If previous match has API position, move current match down
          else if (prevMatch.position) {
            currentMatch.top = prevBottom + requiredGap;
          }
          // If neither has API position, move current match to maintain gap
          else {
            currentMatch.top = prevBottom + requiredGap;
          }
        }
      }
    },
    // Add this method to determine extension direction based on available space
    getExtensionDirection(currentMatch, currentRound, matchIndex, sourceGame, prevRound) {
      // Find the position of source game in previous round
      const sourceGameIndex = prevRound.findIndex(game => game.id === sourceGame.id);

      // Check if there are games above and below the source game
      const hasGameAbove = sourceGameIndex > 0;
      const hasGameBelow = sourceGameIndex < prevRound.length - 1;

      // If source game is at the top, extend upward (toward empty space)
      if (!hasGameAbove) {
        return 'up';
      }

      // If source game is at the bottom, extend downward (toward empty space)
      if (!hasGameBelow) {
        return 'down';
      }

      // If source game is in the middle, determine based on current match position
      // Even indices extend up, odd indices extend down
      return matchIndex % 2 === 0 ? 'up' : 'down';
    },

    // Updated findSourceGames method to handle both winner and loser brackets
    findSourceGamesForBracket(currentMatch, prevRound, bracketGames) {
      const sourceGames = [];

      // Get the current game data from bracketGames
      const currentGameData = bracketGames.find(game => game.id === currentMatch.id);

      if (!currentGameData) return sourceGames;

      // Parse source teams to find which games they come from
      const sourceTeam1 = this.parseSourceTeam(currentGameData.source_team_1);
      const sourceTeam2 = this.parseSourceTeam(currentGameData.source_team_2);

      // Find source games in the previous round
      if (sourceTeam1.type === 'game' && sourceTeam1.id) {
        const sourceGame = prevRound.find(game => game.id === sourceTeam1.id);
        if (sourceGame) {
          sourceGames.push(sourceGame);
        }
      }

      if (sourceTeam2.type === 'game' && sourceTeam2.id) {
        const sourceGame = prevRound.find(game => game.id === sourceTeam2.id);
        if (sourceGame && !sourceGames.find(g => g.id === sourceGame.id)) {
          sourceGames.push(sourceGame);
        }
      }

      return sourceGames;
    },

    // Add this method to determine if a match is in upper or lower bracket position
    isUpperBracketPosition(currentRound, matchIndex) {
      const totalMatches = currentRound.length;
      const midPoint = totalMatches / 2;

      return matchIndex < midPoint;
    },
  },
};
</script>